<template>
    <v-row dense>
        <v-col
            :cols="!readonly && !noDatatableSelect ? 11 : 12"
        >
            <v-autocomplete
                dense
                outlined
                v-model="select"
                @input="handleInput"
                :items="items"
                :search-input.sync="search"
                :item-text="displayName"
                return-object
                :rules="rules"
                no-filter
                flat
                hide-no-data
                :readonly="readonly"
                :clearable="clearable && !readonly"
                hide-details
                :label="label || $t('Department')"
            ></v-autocomplete>
        </v-col>
        <v-col cols="1" v-if="!readonly && !noDatatableSelect">
            <v-btn
                class="float-right mt-1"
                color="primary"
                fab
                x-small
                depressed
                @click="openDepartmentDataTable"
            >
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </v-col>
        <v-dialog
            v-if="!noDatatableSelect"
            v-model="departmentDatatableDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn
                        icon
                        dark
                        @click="departmentDatatableDialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('Department') }}</v-toolbar-title>
                </v-toolbar>
                <v-list three-line subheader>
                    <v-wm-department-table
                        only-select
                        @select="departmentDialogSelect"
                        :parent-code="parentCode"
                        :parent-code-or-zero="parentCodeOrZero"
                        :include-deleted="includeDeleted"
                        :has-department-access-with-type="hasDepartmentAccessWithType"
                        :has-ward="hasWard"
                    ></v-wm-department-table>
                </v-list>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import VWmDepartmentTable from '@/component/department/table.vue';
import departmentService from '@/service/department-service';

export default {
    components: {
        VWmDepartmentTable,
    },
    props: {
        value: Number,
        label: String,
        parentCode: Number,
        parentCodeOrZero: Number,
        noDatatableSelect: Boolean,
        clearable: Boolean,
        rules: Array,
        includeDeleted: Boolean,
        readonly: Boolean,
        hasWard: Boolean,
        hasDepartmentAccessWithType: Number
    },
    data() {
        return {
            items: [],
            search: null,
            select: null,
            timer: null,
            getDataAbort: null,

            departmentDatatableDialog: false,
        };
    },
    mounted() {
        if (this.value) {
            this.setSelected(this.value);
        }
    },
    watch: {
        search(value, oldValue) {
            if (value !== oldValue) {
                if (
                    value !== (this.select && this.select.code) &&
                    value !== this.displayName(this.select)
                ) {
                    clearTimeout(this.timer);
                    this.items = [];
                    if (this.getDataAbort) {
                        this.getDataAbort.abort();
                    }
                    if (value) {
                        this.timer = setTimeout(
                            () => this.querySelections(value),
                            300
                        );
                    }
                }
            }
        },
        value(val) {
            if (!val) {
                this.search = null;
                this.select = null;
                this.items = [];
            } else {
                this.setSelected(val);
            }
        },
    },
    methods: {
        async getData(filter, callback) {
            if (this.getDataAbort) {
                this.getDataAbort.abort();
                this.items = [];
            }
            this.getDataAbort = new AbortController();
            let departmentFilter = filter.code > 0
                ? {
                    code: filter.code,
                    include_deleted: true
                } : {
                    ...filter,
                    branch_code: this.parentCode,
                    branch_code_or_zero: this.parentCodeOrZero,
                    include_deleted: this.includeDeleted,
                    hasWard: this.hasWard,
                    hasDepartmentAccessWithType: this.hasDepartmentAccessWithType
                };
            departmentService
                .getData(
                    1,
                    20,
                    departmentFilter,
                    this.getDataAbort && this.getDataAbort.signal
                )
                .then((response) => callback(response))
                .finally(() => {
                    this.getDataAbort = null;
                });
        },
        querySelections(search) {
            this.getData(
                { search },
                (response) => (this.items = response.data)
            );
        },
        handleInput() {
            this.$emit('input', this.select && this.select.code);
        },
        setSelected(value) {
            if (value && value !== (this.select && this.select.code)) {
                this.getData({ code: value }, (response) => {
                    var data = response.data.filter((d) => d.code == value);
                    if (data.length > 0) {
                        this.items = data;
                        this.select = data[0];
                        this.$emit('input', this.select && this.select.code);
                    }
                });
            }
        },
        departmentDialogSelect(value) {
            this.setSelected(value);
            this.departmentDatatableDialog = false;
        },
        openDepartmentDataTable() {
            this.departmentDatatableDialog = true;
        },
        displayName(item) {
            if (item) {
                return `[${item.code}] ${item.name || ''}`;
            }
            return null;
        },
    },
};
</script>

<style>
</style>